// ============================================================
// COVRFLY® — Selector de Acabado + Barras de Atributos
// Versión: 10.1.0 (V10: single init, try/finally guard, PO-aware CTA gate)
// Producto: Acabado Matte Premium / Glossy
// Dependencias: variant-selects (Shopify), FINAL-covrfly-model-selector.js
// ============================================================
(function () {
  'use strict';

  var LOG = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[COVRFLY Finish]');
    console.log.apply(console, args);
  };

  function finishDone() {
    if (typeof window.cfPdpDone === 'function') window.cfPdpDone('finish');
  }

  if (window.__covrflyFinish && window.__covrflyFinish.cleanup) {
    window.__covrflyFinish.cleanup();
  }

  var variantSelects = document.querySelector('variant-selects:not([style*="display: none"])')
    || document.querySelector('variant-selects');
  if (!variantSelects) { LOG('No variant-selects'); finishDone(); return; }

  var acabadoSelect = variantSelects.querySelector('select[name="options[Acabado]"]')
    || document.querySelector('select[name="options[Acabado]"]');

  if (!acabadoSelect) {
    LOG('No option3 Acabado — abortando');
    finishDone();
    return;
  }

  LOG('option3 encontrado, valor actual:', acabadoSelect.value);

  // Anti-FOUC: ocultar precio hasta que la variante correcta esté seteada
  var priceBlock = document.querySelector('.price--large') || document.querySelector('.price');
  var priceHidden = false;
  if (priceBlock && acabadoSelect) {
    priceBlock.style.opacity = '0';
    priceBlock.style.transition = 'opacity .15s ease';
    priceHidden = true;
    LOG('Precio oculto temporalmente (anti-FOUC)');
  }

  var acabadoContainer = acabadoSelect.closest('.product-form__input');
  if (acabadoContainer) acabadoContainer.classList.add('cf-fin-hidden');

  var styleEl = document.createElement('style');
  styleEl.id = 'covrfly-finish-styles';
  styleEl.textContent = '.cf-fin-hidden{display:none!important}.product-form__input:has(select[name="options[Acabado]"]):not(#covrfly-finish-wrap *){display:none!important}'
    + '.cf-fin-bars{background:#fafafa;border-radius:16px;padding:16px 18px;margin-bottom:14px}'
    + '.cf-fin-bars-hdr{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}'
    + '.cf-fin-bars-title{font-size:13px;font-weight:600;color:#1a1a1a}'
    + '.cf-fin-badge{font-size:11px;font-weight:600;color:#E85D3A;letter-spacing:0;line-height:1}'
    + '.cf-fin-card:not(.is-selected) .cf-fin-badge{color:#E85D3A;animation:none}'
    + '.cf-fin-bar-row{display:flex;align-items:center;gap:8px;margin-bottom:7px}'
    + '.cf-fin-bar-row:last-child{margin-bottom:0}'
    + '.cf-fin-bar-lbl{font-size:12px;color:#888;width:82px;flex-shrink:0}'
    + '.cf-fin-bar-track{flex:1;height:3px;background:#e5e5e5;border-radius:9999px;overflow:hidden}'
    + '.cf-fin-bar-fill{height:100%;background:#1a1a1a;border-radius:9999px;transition:width .35s ease-out}'
    + '.cf-fin-bar-val{font-size:11px;font-weight:500;color:#1a1a1a;min-width:72px;text-align:right}'
    + '.cf-fin-cards-section{margin-top:14px}'
    + '.cf-fin-cards-hdr{font-size:20px;font-weight:700;color:#000;margin-bottom:14px;letter-spacing:-0.01em;line-height:1.2;transition:color .25s ease}'
    + '.cf-fin-cards-hdr.cf-fin-required{color:#000}'
    + '.cf-fin-bars.cf-fin-bars-neutral .cf-fin-bar-fill{opacity:.25}'
    + '.cf-fin-bars.cf-fin-bars-neutral .cf-fin-bar-val{color:#bbb;font-weight:400}'
    + '@keyframes cf-finish-pulse{0%,100%{box-shadow:0 0 0 0 rgba(0,0,0,0)}50%{box-shadow:0 0 0 4px rgba(0,0,0,.04)}}'
    + '.cf-fin-cards-section.cf-fin-pulse{animation:cf-finish-pulse 900ms ease-out 1}'
    + '.cf-fin-cards{display:flex;flex-direction:column;gap:10px}'
    + '.cf-fin-card{position:relative;display:flex;align-items:center;gap:14px;padding:16px 18px;border-radius:16px;cursor:pointer;overflow:hidden;transition:border-color .3s ease,opacity .3s ease,box-shadow .3s ease,background .3s ease}'
    + '@keyframes cf-mate-breathe{0%,100%{box-shadow:0 4px 12px rgba(0,0,0,.08)}50%{box-shadow:0 12px 32px rgba(0,0,0,.22)}}'
    + '.cf-fin-card.mate.is-selected{background:linear-gradient(135deg,#fff 0%,#f0f0f0 100%);border:2px solid #000;box-shadow:0 4px 12px rgba(0,0,0,.08);padding:15px 17px;animation:cf-mate-breathe 4s ease-in-out infinite}'
    + '.cf-fin-card.mate:not(.is-selected){background:#fff;border:1.5px solid #d4d4d4;opacity:1}'
    + '.cf-fin-card.mate:not(.is-selected):hover{opacity:.95;border-color:#d4d4d4}'
    + '.cf-fin-card.glossy{background:#fff;border:1.5px solid #d4d4d4;opacity:1}'
    + '.cf-fin-card.glossy:hover{opacity:.95;border-color:#d4d4d4}'
    + '.cf-fin-card.glossy.is-selected{border:2px solid #000;opacity:1;background:#f5f5f5;padding:15px 17px}'
    + '@keyframes cf-glossy-sheen{0%{left:-100%;opacity:0}8%{opacity:1}35%{left:150%;opacity:1}45%{opacity:0}100%{left:150%;opacity:0}}'
    + '.cf-fin-card.glossy.is-selected::after{content:"";position:absolute;top:0;left:-100%;width:60%;height:100%;background:linear-gradient(90deg,transparent 0%,rgba(255,255,255,.4) 40%,rgba(255,255,255,.8) 50%,rgba(255,255,255,.4) 60%,transparent 100%);transform:skewX(-20deg);animation:cf-glossy-sheen 3.2s ease-in-out infinite;pointer-events:none}'
    + '.cf-fin-card-row{display:flex;align-items:center;gap:14px;width:100%}'
    + '.cf-fin-card-info{flex:1}'
    + '.cf-fin-card-name{font-size:15px;font-weight:600;color:#000;line-height:1.3;display:flex;align-items:center;gap:7px;overflow:visible}'
    + '.cf-fin-card-sub{font-size:12px;color:#525252;margin-top:2px}'
    + '.cf-fin-card-mag{font-size:12px;color:#525252;margin-top:2px;display:flex;align-items:center;transition:color .2s}'
    + '.cf-fin-mag-icon{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;vertical-align:middle;margin-right:5px;color:inherit;transition:color .2s}'
    + '.cf-fin-mag-icon svg{width:100%;height:100%}'
    + '.cf-fin-card:not(.is-selected) .cf-fin-card-name{color:#444}'
    + '.cf-fin-card:not(.is-selected) .cf-fin-card-sub{color:#777}'
    + '.cf-fin-card:not(.is-selected) .cf-fin-card-mag{color:#777}'
    + '.cf-fin-card-icon{width:50px;height:50px;min-width:50px;color:#000;display:flex;align-items:center;justify-content:center;transition:color .2s}'
    + '.cf-fin-card-icon svg{width:100%;height:100%}'
    + '.cf-fin-card-delta{background:#f5f5f5;color:#555;font-size:13px;font-weight:400;padding:6px 12px;border-radius:99px;border:1px solid #e5e5e5;white-space:nowrap}'
    + '.cf-fin-card-delta.cf-fin-delta-neg{color:#888}'
    + '.cf-fin-preorder-badge{display:inline-flex;align-items:center;justify-content:center;padding:4px 10px;border-radius:999px;background:#1d1d1f;color:#ffffff;border:1px solid #1d1d1f;font-size:12px;font-weight:600;line-height:1.3;letter-spacing:-0.01em;white-space:nowrap;vertical-align:middle;margin-left:6px;align-self:center;font-family:inherit}'
    + '.cf-fin-preorder-badge[hidden]{display:none!important}'
    + '@media(max-width:400px){.cf-fin-preorder-badge{font-size:11px;padding:3.5px 9px}}'
    + '.cf-fin-card-delta.cf-fin-delta-preorder{background:#1d1d1f;color:#ffffff;border:1px solid #1d1d1f;font-weight:650;letter-spacing:-0.01em;white-space:nowrap}'
    + '.cf-fin-card:not(.is-selected) .cf-fin-card-delta{color:#555;border-color:#d4d4d4}'
    + '@media(max-width:400px){.cf-fin-card{padding:14px 16px;gap:12px}.cf-fin-card.mate.is-selected,.cf-fin-card.glossy.is-selected{padding:13px 15px}.cf-fin-card-name{font-size:14px}.cf-fin-card-delta{font-size:12px;padding:5px 10px}}'
    + '@media(prefers-reduced-motion:reduce){.cf-fin-card.mate.is-selected{animation:none}.cf-fin-card.glossy.is-selected::after{animation:none;display:none}}'
    + '#covrfly-magsafe-wrap.cf-fin-magsafe-hidden{display:none!important}'
    + '#covrfly-finish-wrap .cf-fin-cards-section{transition:background .3s ease,box-shadow .3s ease,padding .3s ease,border-radius .3s ease}'
    + '#covrfly-finish-wrap.cf-fin-attention .cf-fin-cards-section{background:#f7f7f7;border-radius:16px;padding:18px 16px;margin-top:14px;animation:cf-finish-breathe 4.8s ease-in-out infinite}'
    + '@keyframes cf-finish-breathe{0%,100%{box-shadow:0 0 0 0 rgba(0,0,0,0.04)}50%{box-shadow:0 0 0 6px rgba(0,0,0,0.07)}}'
    + '@media(prefers-reduced-motion:reduce){#covrfly-finish-wrap.cf-fin-attention .cf-fin-cards-section{animation:none}}'
    + '.cf-finish-required-btn{color:transparent!important;position:relative}'
    + '.cf-finish-required-btn::after{content:"Elige tu acabado";color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:1;visibility:visible;pointer-events:none;white-space:nowrap}';
  document.head.appendChild(styleEl);

  var modelSelect = variantSelects.querySelector('select[name="options[Modelo]"]')
    || document.querySelector('select[name="options[Modelo]"]');
  var magsafeSelect = variantSelects.querySelector('select[name="options[MagSafe]"]')
    || document.querySelector('select[name="options[MagSafe]"]');

  // === CONFIGURACIÓN ===
  var MATTE_MODELS = new Set([
    'iPhone 17 Pro Max', 'iPhone 17 Pro',
    'iPhone 16 Pro Max', 'iPhone 16 Pro',
    'iPhone 15 Pro Max', 'iPhone 15 Pro',
    'Galaxy S26 Ultra', 'Galaxy S25 Ultra'
  ]);

  // IP18 ROLLOUT START: enable only the four complete public variant tuples.
  function hasPublishedIP18() {
    try {
      var publicVariants = JSON.parse(variantSelects.querySelector('script[type="application/json"]').textContent);
      var expected = [
        ['iPhone 18 Pro Max', 'Glossy'],
        ['iPhone 18 Pro Max', 'Matte Premium'],
        ['iPhone 18 Pro', 'Glossy'],
        ['iPhone 18 Pro', 'Matte Premium']
      ];
      if (!Array.isArray(publicVariants)) return false;
      var matches = expected.map(function(row) {
        return publicVariants.filter(function(v) {
          return v && v.option1 === row[0] && v.option2 === 'Si' && v.option3 === row[1];
        });
      });
      return matches.every(function(rows) {
        return rows.length === 1 && Number.isSafeInteger(rows[0].id) && rows[0].id > 0;
      }) && new Set(matches.map(function(rows) { return rows[0].id; })).size === 4;
    } catch (e) { return false; }
  }
  if (hasPublishedIP18()) {
    MATTE_MODELS.add('iPhone 18 Pro Max');
    MATTE_MODELS.add('iPhone 18 Pro');
  }
  // IP18 ROLLOUT END

  var BAR_DATA = {
    mate: [
      { width: '90%', text: 'Imperceptible' },
      { width: '90%', text: 'M\u00e1xima' },
      { width: '90%', text: 'M\u00ednimo' }
    ],
    glossy: [
      { width: '67%', text: 'Moderado' },
      { width: '85%', text: 'Alta' },
      { width: '80%', text: 'Natural' }
    ]
  };

  function isSamsung(model) { return /galaxy|samsung/i.test(model); }
  function hasMatte(model) { return MATTE_MODELS.has(model); }

  function modelHasNoVariant(model) {
    var jsonEl = variantSelects.querySelector('script[type="application/json"]');
    if (!jsonEl) return true;
    try {
      var variants = JSON.parse(jsonEl.textContent);
      return variants.some(function(v) { return v.option1 === model && v.option2 === 'No'; });
    } catch(e) { return true; }
  }

  function hideMagsafeForMate() {
    var msWrap = document.getElementById('covrfly-magsafe-wrap');
    if (msWrap) msWrap.classList.add('cf-fin-magsafe-hidden');
  }

  function showMagsafeForGlossy() {
    var msWrap = document.getElementById('covrfly-magsafe-wrap');
    if (msWrap) msWrap.classList.remove('cf-fin-magsafe-hidden');
  }

  var finishWrap = document.createElement('div');
  finishWrap.id = 'covrfly-finish-wrap';

  finishWrap.innerHTML = '<div class="cf-fin-bars">'
    + '<div class="cf-fin-bars-hdr">'
    + '<span class="cf-fin-bars-title">Acabado Matte Premium</span>'
    + '<span class="cf-fin-badge">M\u00e1s popular</span>'
    + '</div>'
    + '<div class="cf-fin-bar-row">'
    + '<span class="cf-fin-bar-lbl">Anti-huellas</span>'
    + '<div class="cf-fin-bar-track"><div class="cf-fin-bar-fill" style="width:90%"></div></div>'
    + '<span class="cf-fin-bar-val">Imperceptible</span>'
    + '</div>'
    + '<div class="cf-fin-bar-row">'
    + '<span class="cf-fin-bar-lbl">Protecci\u00f3n</span>'
    + '<div class="cf-fin-bar-track"><div class="cf-fin-bar-fill" style="width:90%"></div></div>'
    + '<span class="cf-fin-bar-val">M\u00e1xima</span>'
    + '</div>'
    + '<div class="cf-fin-bar-row">'
    + '<span class="cf-fin-bar-lbl">Desgaste</span>'
    + '<div class="cf-fin-bar-track"><div class="cf-fin-bar-fill" style="width:90%"></div></div>'
    + '<span class="cf-fin-bar-val">M\u00ednimo</span>'
    + '</div>'
    + '</div>'
    // Sección de tarjetas
    + '<div class="cf-fin-cards-section">'
    + '<div class="cf-fin-cards-hdr">Elige tu acabado</div>'
    + '<div class="cf-fin-cards">'
    // Tarjeta Mate
    + '<div class="cf-fin-card mate" data-value="Matte Premium" role="radio" aria-checked="false" tabindex="0">'
    + '<div class="cf-fin-card-row">'
    + '<div class="cf-fin-card-info">'
    + '<div class="cf-fin-card-name">Matte Premium <span class="cf-fin-badge">M\u00e1s popular</span></div>'
    + '<div class="cf-fin-card-sub">Suave al tacto</div>'
    + '<div class="cf-fin-card-mag"><span class="cf-fin-mag-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.61 1034.66"><path d="M373.8 15c48.44 0 95.43 9.48 139.66 28.19 42.72 18.07 81.1 43.94 114.05 76.9s58.83 71.33 76.9 114.05c18.71 44.23 28.19 91.21 28.19 139.66s-9.48 95.43-28.19 139.66c-18.07 42.72-43.94 81.1-76.9 114.05s-71.33 58.83-114.05 76.9c-44.23 18.71-91.21 28.19-139.66 28.19s-95.43-9.48-139.66-28.19c-42.72-18.07-81.1-43.94-114.05-76.9s-58.83-71.33-76.9-114.05C24.48 469.23 15 422.25 15 373.8s9.48-95.43 28.19-139.66c18.07-42.72 43.94-81.1 76.9-114.05s71.33-58.83 114.05-76.9C278.37 24.48 325.35 15 373.8 15m0-15C167.36 0 0 167.36 0 373.8s167.36 373.8 373.8 373.8 373.8-167.36 373.8-373.8S580.25 0 373.8 0Z" fill="currentColor"/><path d="M373.8 103.03c36.56 0 72.02 7.16 105.39 21.27 32.24 13.64 61.2 33.16 86.07 58.03 24.87 24.87 44.4 53.83 58.03 86.07 14.12 33.37 21.27 68.83 21.27 105.39s-7.16 72.02-21.27 105.39c-13.64 32.24-33.16 61.2-58.03 86.07-24.87 24.87-53.83 44.4-86.07 58.03-33.37 14.12-68.83 21.27-105.39 21.27s-72.02-7.16-105.39-21.27c-32.24-13.64-61.2-33.16-86.07-58.03-24.87-24.87-44.4-53.83-58.03-86.07-14.12-33.37-21.27-68.83-21.27-105.39s7.16-72.02 21.27-105.39c13.64-32.24 33.16-61.2 58.03-86.07 24.87-24.87 53.83-44.4 86.07-58.03 33.37-14.12 68.83-21.27 105.39-21.27m0-14.87c-157.75 0-285.64 127.89-285.64 285.64S216.05 659.44 373.8 659.44 659.44 531.55 659.44 373.8 531.56 88.16 373.8 88.16ZM372.79 811.48c20.12 0 36.49 16.37 36.49 36.49v135.2c0 20.12-16.37 36.49-36.49 36.49s-36.49-16.37-36.49-36.49v-135.2c0-20.12 16.37-36.49 36.49-36.49m0-15c-28.44 0-51.49 23.05-51.49 51.49v135.2c0 28.44 23.05 51.49 51.49 51.49s51.49-23.05 51.49-51.49v-135.2c0-28.44-23.05-51.49-51.49-51.49Z" fill="currentColor"/><path d="M335.92 553.7c-2.02 0-4.01-.33-5.92-.97-8.98-3.04-11.28-10.45-11.63-16.14-.15-2.26.05-4.63.6-7.24l23.93-115.17s.01-.07.01-.1c0-.28-.22-.5-.5-.5l-68.58 1.05c-8.42 0-15.85-5.15-18.5-12.83-1.37-3.98-1.35-7.82.05-11.4.49-1.26 1.22-2.53 2.24-3.89l138.09-184.27c3.75-5 9.63-7.99 15.73-7.99 2.02 0 4.01.33 5.92.97 8.98 3.04 11.28 10.45 11.63 16.14.15 2.26-.05 4.62-.6 7.24l-23.93 115.18c-.05.25.1.5.34.58.05.02.1.02.15.02l68.58-1.05c8.41 0 15.85 5.15 18.5 12.83 1.37 3.98 1.35 7.82-.05 11.41-.48 1.24-1.22 2.51-2.24 3.88l-37.66 50.26-100.43 134.01c-3.75 5-9.63 7.99-15.73 7.99Z" fill="currentColor"/></svg></span>Edici\u00f3n MagSafe</div>'
    + '</div>'
    + '<div class="cf-fin-card-delta" style="display:none">+ $100</div>'
    + '<div class="cf-fin-card-icon" style="display:none"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.61 1034.66"><path d="M373.8 15c48.44 0 95.43 9.48 139.66 28.19 42.72 18.07 81.1 43.94 114.05 76.9s58.83 71.33 76.9 114.05c18.71 44.23 28.19 91.21 28.19 139.66s-9.48 95.43-28.19 139.66c-18.07 42.72-43.94 81.1-76.9 114.05s-71.33 58.83-114.05 76.9c-44.23 18.71-91.21 28.19-139.66 28.19s-95.43-9.48-139.66-28.19c-42.72-18.07-81.1-43.94-114.05-76.9s-58.83-71.33-76.9-114.05C24.48 469.23 15 422.25 15 373.8s9.48-95.43 28.19-139.66c18.07-42.72 43.94-81.1 76.9-114.05s71.33-58.83 114.05-76.9C278.37 24.48 325.35 15 373.8 15m0-15C167.36 0 0 167.36 0 373.8s167.36 373.8 373.8 373.8 373.8-167.36 373.8-373.8S580.25 0 373.8 0Z" fill="currentColor"/><path d="M373.8 103.03c36.56 0 72.02 7.16 105.39 21.27 32.24 13.64 61.2 33.16 86.07 58.03 24.87 24.87 44.4 53.83 58.03 86.07 14.12 33.37 21.27 68.83 21.27 105.39s-7.16 72.02-21.27 105.39c-13.64 32.24-33.16 61.2-58.03 86.07-24.87 24.87-53.83 44.4-86.07 58.03-33.37 14.12-68.83 21.27-105.39 21.27s-72.02-7.16-105.39-21.27c-32.24-13.64-61.2-33.16-86.07-58.03-24.87-24.87-44.4-53.83-58.03-86.07-14.12-33.37-21.27-68.83-21.27-105.39s7.16-72.02 21.27-105.39c13.64-32.24 33.16-61.2 58.03-86.07 24.87-24.87 53.83-44.4 86.07-58.03 33.37-14.12 68.83-21.27 105.39-21.27m0-14.87c-157.75 0-285.64 127.89-285.64 285.64S216.05 659.44 373.8 659.44 659.44 531.55 659.44 373.8 531.56 88.16 373.8 88.16ZM372.79 811.48c20.12 0 36.49 16.37 36.49 36.49v135.2c0 20.12-16.37 36.49-36.49 36.49s-36.49-16.37-36.49-36.49v-135.2c0-20.12 16.37-36.49 36.49-36.49m0-15c-28.44 0-51.49 23.05-51.49 51.49v135.2c0 28.44 23.05 51.49 51.49 51.49s51.49-23.05 51.49-51.49v-135.2c0-28.44-23.05-51.49-51.49-51.49Z" fill="currentColor"/><path d="M335.92 553.7c-2.02 0-4.01-.33-5.92-.97-8.98-3.04-11.28-10.45-11.63-16.14-.15-2.26.05-4.63.6-7.24l23.93-115.17s.01-.07.01-.1c0-.28-.22-.5-.5-.5l-68.58 1.05c-8.42 0-15.85-5.15-18.5-12.83-1.37-3.98-1.35-7.82.05-11.4.49-1.26 1.22-2.53 2.24-3.89l138.09-184.27c3.75-5 9.63-7.99 15.73-7.99 2.02 0 4.01.33 5.92.97 8.98 3.04 11.28 10.45 11.63 16.14.15 2.26-.05 4.62-.6 7.24l-23.93 115.18c-.05.25.1.5.34.58.05.02.1.02.15.02l68.58-1.05c8.41 0 15.85 5.15 18.5 12.83 1.37 3.98 1.35 7.82-.05 11.41-.48 1.24-1.22 2.51-2.24 3.88l-37.66 50.26-100.43 134.01c-3.75 5-9.63 7.99-15.73 7.99Z" fill="currentColor"/></svg></div>'
    + '</div>'
    + '</div>'
    // Tarjeta Glossy
    + '<div class="cf-fin-card glossy" data-value="Glossy" role="radio" aria-checked="false" tabindex="0">'
    + '<div class="cf-fin-card-row">'
    + '<div class="cf-fin-card-info">'
    + '<div class="cf-fin-card-name">Glossy</div>'
    + '<div class="cf-fin-card-sub">Acabado brillante</div>'
    + '<div class="cf-fin-card-mag cf-fin-glossy-mag" style="display:none"><span class="cf-fin-mag-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.61 1034.66"><path d="M373.8 15c48.44 0 95.43 9.48 139.66 28.19 42.72 18.07 81.1 43.94 114.05 76.9s58.83 71.33 76.9 114.05c18.71 44.23 28.19 91.21 28.19 139.66s-9.48 95.43-28.19 139.66c-18.07 42.72-43.94 81.1-76.9 114.05s-71.33 58.83-114.05 76.9c-44.23 18.71-91.21 28.19-139.66 28.19s-95.43-9.48-139.66-28.19c-42.72-18.07-81.1-43.94-114.05-76.9s-58.83-71.33-76.9-114.05C24.48 469.23 15 422.25 15 373.8s9.48-95.43 28.19-139.66c18.07-42.72 43.94-81.1 76.9-114.05s71.33-58.83 114.05-76.9C278.37 24.48 325.35 15 373.8 15m0-15C167.36 0 0 167.36 0 373.8s167.36 373.8 373.8 373.8 373.8-167.36 373.8-373.8S580.25 0 373.8 0Z" fill="currentColor"/><path d="M373.8 103.03c36.56 0 72.02 7.16 105.39 21.27 32.24 13.64 61.2 33.16 86.07 58.03 24.87 24.87 44.4 53.83 58.03 86.07 14.12 33.37 21.27 68.83 21.27 105.39s-7.16 72.02-21.27 105.39c-13.64 32.24-33.16 61.2-58.03 86.07-24.87 24.87-53.83 44.4-86.07 58.03-33.37 14.12-68.83 21.27-105.39 21.27s-72.02-7.16-105.39-21.27c-32.24-13.64-61.2-33.16-86.07-58.03-24.87-24.87-44.4-53.83-58.03-86.07-14.12-33.37-21.27-68.83-21.27-105.39s7.16-72.02 21.27-105.39c13.64-32.24 33.16-61.2 58.03-86.07 24.87-24.87 53.83-44.4 86.07-58.03 33.37-14.12 68.83-21.27 105.39-21.27m0-14.87c-157.75 0-285.64 127.89-285.64 285.64S216.05 659.44 373.8 659.44 659.44 531.55 659.44 373.8 531.56 88.16 373.8 88.16ZM372.79 811.48c20.12 0 36.49 16.37 36.49 36.49v135.2c0 20.12-16.37 36.49-36.49 36.49s-36.49-16.37-36.49-36.49v-135.2c0-20.12 16.37-36.49 36.49-36.49m0-15c-28.44 0-51.49 23.05-51.49 51.49v135.2c0 28.44 23.05 51.49 51.49 51.49s51.49-23.05 51.49-51.49v-135.2c0-28.44-23.05-51.49-51.49-51.49Z" fill="currentColor"/><path d="M335.92 553.7c-2.02 0-4.01-.33-5.92-.97-8.98-3.04-11.28-10.45-11.63-16.14-.15-2.26.05-4.63.6-7.24l23.93-115.17s.01-.07.01-.1c0-.28-.22-.5-.5-.5l-68.58 1.05c-8.42 0-15.85-5.15-18.5-12.83-1.37-3.98-1.35-7.82.05-11.4.49-1.26 1.22-2.53 2.24-3.89l138.09-184.27c3.75-5 9.63-7.99 15.73-7.99 2.02 0 4.01.33 5.92.97 8.98 3.04 11.28 10.45 11.63 16.14.15 2.26-.05 4.62-.6 7.24l-23.93 115.18c-.05.25.1.5.34.58.05.02.1.02.15.02l68.58-1.05c8.41 0 15.85 5.15 18.5 12.83 1.37 3.98 1.35 7.82-.05 11.41-.48 1.24-1.22 2.51-2.24 3.88l-37.66 50.26-100.43 134.01c-3.75 5-9.63 7.99-15.73 7.99Z" fill="currentColor"/></svg></span>Edici\u00f3n MagSafe</div>'
    + '</div>'
    + '<div class="cf-fin-card-delta cf-fin-delta-neg">- $100</div>'
    + '<div class="cf-fin-card-icon cf-fin-glossy-icon" style="display:none"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.61 1034.66"><path d="M373.8 15c48.44 0 95.43 9.48 139.66 28.19 42.72 18.07 81.1 43.94 114.05 76.9s58.83 71.33 76.9 114.05c18.71 44.23 28.19 91.21 28.19 139.66s-9.48 95.43-28.19 139.66c-18.07 42.72-43.94 81.1-76.9 114.05s-71.33 58.83-114.05 76.9c-44.23 18.71-91.21 28.19-139.66 28.19s-95.43-9.48-139.66-28.19c-42.72-18.07-81.1-43.94-114.05-76.9s-58.83-71.33-76.9-114.05C24.48 469.23 15 422.25 15 373.8s9.48-95.43 28.19-139.66c18.07-42.72 43.94-81.1 76.9-114.05s71.33-58.83 114.05-76.9C278.37 24.48 325.35 15 373.8 15m0-15C167.36 0 0 167.36 0 373.8s167.36 373.8 373.8 373.8 373.8-167.36 373.8-373.8S580.25 0 373.8 0Z" fill="currentColor"/><path d="M373.8 103.03c36.56 0 72.02 7.16 105.39 21.27 32.24 13.64 61.2 33.16 86.07 58.03 24.87 24.87 44.4 53.83 58.03 86.07 14.12 33.37 21.27 68.83 21.27 105.39s-7.16 72.02-21.27 105.39c-13.64 32.24-33.16 61.2-58.03 86.07-24.87 24.87-53.83 44.4-86.07 58.03-33.37 14.12-68.83 21.27-105.39 21.27s-72.02-7.16-105.39-21.27c-32.24-13.64-61.2-33.16-86.07-58.03-24.87-24.87-44.4-53.83-58.03-86.07-14.12-33.37-21.27-68.83-21.27-105.39s7.16-72.02 21.27-105.39c13.64-32.24 33.16-61.2 58.03-86.07 24.87-24.87 53.83-44.4 86.07-58.03 33.37-14.12 68.83-21.27 105.39-21.27m0-14.87c-157.75 0-285.64 127.89-285.64 285.64S216.05 659.44 373.8 659.44 659.44 531.55 659.44 373.8 531.56 88.16 373.8 88.16ZM372.79 811.48c20.12 0 36.49 16.37 36.49 36.49v135.2c0 20.12-16.37 36.49-36.49 36.49s-36.49-16.37-36.49-36.49v-135.2c0-20.12 16.37-36.49 36.49-36.49m0-15c-28.44 0-51.49 23.05-51.49 51.49v135.2c0 28.44 23.05 51.49 51.49 51.49s51.49-23.05 51.49-51.49v-135.2c0-28.44-23.05-51.49-51.49-51.49Z" fill="currentColor"/><path d="M335.92 553.7c-2.02 0-4.01-.33-5.92-.97-8.98-3.04-11.28-10.45-11.63-16.14-.15-2.26.05-4.63.6-7.24l23.93-115.17s.01-.07.01-.1c0-.28-.22-.5-.5-.5l-68.58 1.05c-8.42 0-15.85-5.15-18.5-12.83-1.37-3.98-1.35-7.82.05-11.4.49-1.26 1.22-2.53 2.24-3.89l138.09-184.27c3.75-5 9.63-7.99 15.73-7.99 2.02 0 4.01.33 5.92.97 8.98 3.04 11.28 10.45 11.63 16.14.15 2.26-.05 4.62-.6 7.24l-23.93 115.18c-.05.25.1.5.34.58.05.02.1.02.15.02l68.58-1.05c8.41 0 15.85 5.15 18.5 12.83 1.37 3.98 1.35 7.82-.05 11.41-.48 1.24-1.22 2.51-2.24 3.88l-37.66 50.26-100.43 134.01c-3.75 5-9.63 7.99-15.73 7.99Z" fill="currentColor"/></svg></div>'
    + '</div>'
    + '</div>'
    + '</div>'
    + '</div>';

  var triggerWrap = document.getElementById('covrfly-trigger-wrap');
  if (triggerWrap) {
    triggerWrap.insertAdjacentElement('afterend', finishWrap);
  } else {
    variantSelects.insertAdjacentElement('beforebegin', finishWrap);
  }

  // === V10: STATE VARIABLES FIRST (Bug 4 fix) ===
  var _updating = false;
  var _currentFinish = 'none';
  var _userHasChosenFinish = false;
  var _savedInitialFinish = acabadoSelect ? acabadoSelect.value : 'Glossy';

  // === ANIMACIÓN DE BARRAS ===
  function animateBars(finish) {
    var data = BAR_DATA[finish] || BAR_DATA.mate;
    var rows = finishWrap.querySelectorAll('.cf-fin-bar-row');
    var title = finishWrap.querySelector('.cf-fin-bars-title');
    if (title) title.textContent = finish === 'matte' ? 'Acabado Matte Premium' : 'Acabado Glossy';

    var badge = finishWrap.querySelector('.cf-fin-bars-hdr .cf-fin-badge');
    if (badge) badge.style.display = (finish === 'matte') ? '' : 'none';

    rows.forEach(function (row, i) {
      var fill = row.querySelector('.cf-fin-bar-fill');
      var val = row.querySelector('.cf-fin-bar-val');
      if (!fill || !val) return;
      fill.style.width = data[i].width;
      val.textContent = data[i].text;
    });
  }

  // === PRE-ORDER HELPERS ===
  function isFinishPreorder(model, finish) {
    if (!window.COVRFLY_PREORDER || typeof window.COVRFLY_PREORDER.isPreorder !== 'function') return false;
    var msVal = magsafeSelect ? magsafeSelect.value : '';
    return window.COVRFLY_PREORDER.isPreorder(model, msVal, finish);
  }

  function getCardByFinish(finish) {
    if (!finishWrap) return null;
    if (finish === 'matte') return finishWrap.querySelector('.cf-fin-card.mate');
    if (finish === 'glossy') return finishWrap.querySelector('.cf-fin-card.glossy');
    return null;
  }

  // === BADGE SYSTEM ===
  function resetPreorderPills() {
    if (!finishWrap) return;
    // V9: Limpiar badges (elemento nuevo independiente del delta)
    var badges = finishWrap.querySelectorAll('.cf-fin-preorder-badge');
    badges.forEach(function(b) {
      b.hidden = true;
    });
    // V9: Limpieza compatibilidad legacy V6/V7 (delta usado como pill)
    var deltas = finishWrap.querySelectorAll('.cf-fin-card-delta');
    deltas.forEach(function(d) {
      if (d.dataset.cfOriginalText) {
        d.textContent = d.dataset.cfOriginalText;
        delete d.dataset.cfOriginalText;
      }
      d.classList.remove('cf-fin-delta-preorder');
    });
  }

  // V9: Helper para crear badge si no existe (idempotente)
  function ensurePreorderBadge(card) {
    if (!card) return null;
    var name = card.querySelector('.cf-fin-card-name');
    if (!name) return null;
    var existing = name.querySelector('.cf-fin-preorder-badge');
    if (existing) return existing;
    // Crear badge nuevo dentro de card-name (estilo "Mas popular")
    var badge = document.createElement('span');
    badge.className = 'cf-fin-preorder-badge';
    badge.textContent = 'Pre-Orden';
    badge.setAttribute('aria-label', 'Pre-Orden');
    badge.hidden = true;
    name.appendChild(document.createTextNode(' '));
    name.appendChild(badge);
    return badge;
  }

  function markFinishAsPreorder(finish) {
    var card = getCardByFinish(finish);
    if (!card) return;
    var badge = ensurePreorderBadge(card);
    if (!badge) return;
    badge.hidden = false;
  }

  function updatePreorderPills(model) {
    resetPreorderPills();
    if (!hasMatte(model)) return;
    if (isFinishPreorder(model, 'Matte Premium')) {
      markFinishAsPreorder('matte');
    }
    if (isFinishPreorder(model, 'Glossy')) {
      markFinishAsPreorder('glossy');
    }
  }

  // === NEUTRAL STATE ===
  function setNeutralState() {
    _currentFinish = 'none'; _userHasChosenFinish = false;
    var cards = finishWrap.querySelectorAll('.cf-fin-card');
    cards.forEach(function(c){c.classList.remove('is-selected');c.setAttribute('aria-checked','false');});
    var t=finishWrap.querySelector('.cf-fin-bars-title'); if(t) t.textContent='Acabado';
    var hb=finishWrap.querySelector('.cf-fin-bars-hdr .cf-fin-badge'); if(hb) hb.style.display='none';
    var bb=finishWrap.querySelector('.cf-fin-bars'); if(bb) bb.classList.add('cf-fin-bars-neutral');
    finishWrap.querySelectorAll('.cf-fin-bar-row').forEach(function(r){
      var f=r.querySelector('.cf-fin-bar-fill'),v=r.querySelector('.cf-fin-bar-val');
      if(f) f.style.width='15%'; if(v) v.textContent='\u2014';
    });
    var sh=finishWrap.querySelector('.cf-fin-cards-hdr');
    if(sh){sh.textContent='Elige el acabado';sh.classList.remove('cf-fin-required');}
    var dp=finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-delta:not(.cf-fin-delta-neg)');
    if(dp) dp.style.display='';
    var dn=finishWrap.querySelector('.cf-fin-delta-neg'); if(dn) dn.style.display='none';
    // V4 Fase 1.7: MagSafe correcto en neutral
    // Icono GRANDE siempre oculto en neutral
    try { hideMagsafeForMate(); } catch(e) {}
    finishWrap.querySelectorAll('.cf-fin-card-icon').forEach(function(el){ el.style.display='none'; });
    // Icono chico + texto: visible en iPhone, oculto en Samsung
    var model = modelSelect ? modelSelect.value : '';
    var samsung = /galaxy|samsung/i.test(model);
    var hasNo = modelHasNoVariant(model);
    var showMagIcons = !samsung && !hasNo;
    if (showMagIcons) {
      // Ambas tarjetas: chico + texto visibles en neutral
      var mMateMag = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-mag-icon');
      if (mMateMag) mMateMag.style.display = 'inline-flex';
      var mMateText = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-mag');
      if (mMateText) mMateText.style.display = '';
      var mGlossyMag = finishWrap.querySelector('.cf-fin-card.glossy .cf-fin-mag-icon');
      if (mGlossyMag) mGlossyMag.style.display = 'inline-flex';
      var mGlossyText = finishWrap.querySelector('.cf-fin-glossy-mag');
      if (mGlossyText) mGlossyText.style.display = '';
    } else {
      finishWrap.querySelectorAll('.cf-fin-mag-icon').forEach(function(el){ el.style.display='none'; });
      finishWrap.querySelectorAll('.cf-fin-card-mag').forEach(function(el){ el.style.display='none'; });
    }

    // V4 Fase 2.5: estado neutral LIMPIO (sin fondo aun)
    finishWrap.classList.add('cf-fin-needs-choice');
    finishWrap.classList.remove('cf-fin-choice-made');
    finishWrap.classList.remove('cf-fin-attention');

    // V5 Fase 2: resetear acabadoSelect a Glossy (precio $799 base)
    if (acabadoSelect && acabadoSelect.value !== 'Glossy') {
      acabadoSelect.value = 'Glossy';
      window.requestAnimationFrame(function(){
        try { acabadoSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch(e){}
      });
    }

    LOG('Estado neutro v5 — precio sincronizado');
  }

  // === V10: REFACTORED selectFinish with try/finally + PO guard ===
  function selectFinish(finish, isUserAction) {
    if (_updating) return;
    _updating = true;
    try {
      _currentFinish = finish;
      _userHasChosenFinish = true;
      var isMate = (finish === 'matte');
      var model = modelSelect ? modelSelect.value : '';
      var samsung = isSamsung(model);

      // 1. Actualizar UI de tarjetas
      var cards = finishWrap.querySelectorAll('.cf-fin-card');
      cards.forEach(function (card) {
        var val = card.getAttribute('data-value');
        var sel = (isMate && val === 'Matte Premium') || (!isMate && val === 'Glossy');
        card.classList.toggle('is-selected', sel);
        card.setAttribute('aria-checked', String(sel));
      });

      // 2. Delta positivo (+ $100 en Mate): visible cuando Glossy seleccionado
      var deltaPos = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-delta:not(.cf-fin-delta-neg)');
      if (deltaPos) deltaPos.style.display = isMate ? 'none' : '';

      // 2. Delta negativo (- $100 en Glossy): visible cuando Mate seleccionado
      var deltaNeg = finishWrap.querySelector('.cf-fin-delta-neg');
      if (deltaNeg) deltaNeg.style.display = isMate ? '' : 'none';

      // 2a. hasNo check para ambas tarjetas
      var hasNo = modelHasNoVariant(model);
      var showMagIcons = !samsung && !hasNo;

      // 2b. SVGs de Mate
      var mateBigIcon = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-icon');
      if (mateBigIcon) mateBigIcon.style.display = (isMate && !samsung) ? 'flex' : 'none';

      var mateSmallIcon = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-mag-icon');
      if (mateSmallIcon) mateSmallIcon.style.display = (!isMate && !samsung) ? 'inline-flex' : 'none';

      // 2c. Texto "Edición MagSafe" (Mate card): visible iPhone, oculto Samsung
      var magText = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-mag');
      if (magText) magText.style.display = !samsung ? '' : 'none';

      // 2d. SVGs de Glossy (homólogo a Mate)
      var glossyBigIcon = finishWrap.querySelector('.cf-fin-glossy-icon');
      if (glossyBigIcon) glossyBigIcon.style.display = (!isMate && showMagIcons) ? 'flex' : 'none';

      var glossySmallIcon = finishWrap.querySelector('.cf-fin-card.glossy .cf-fin-mag-icon');
      if (glossySmallIcon) glossySmallIcon.style.display = (isMate && showMagIcons) ? 'inline-flex' : 'none';

      // 2e. Texto "Edición MagSafe" en Glossy: visible si showMagIcons
      var glossyMag = finishWrap.querySelector('.cf-fin-glossy-mag');
      if (glossyMag) glossyMag.style.display = showMagIcons ? '' : 'none';

      // 2d. Animar barras dinámicas
      animateBars(finish);

      // 2d. MagSafe wrap: ocultar/mostrar
      if (isMate && !samsung) {
        hideMagsafeForMate();
      } else if (!isMate) {
        showMagsafeForGlossy();
      }

      // 3. Setear select nativo de Acabado
      if (acabadoSelect) {
        acabadoSelect.value = isMate ? 'Matte Premium' : 'Glossy';
      }

      // 4. Si Mate, forzar MagSafe correcto
      if (isMate && magsafeSelect) {
        var targetMag = 'Si';
        if (magsafeSelect.value !== targetMag) {
          magsafeSelect.value = targetMag;
          magsafeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // 5. Dispatchar change en Acabado
      if (acabadoSelect) {
        acabadoSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var barsBlock=finishWrap.querySelector('.cf-fin-bars');if(barsBlock)barsBlock.classList.remove('cf-fin-bars-neutral');
      var sectionHdr=finishWrap.querySelector('.cf-fin-cards-hdr');if(sectionHdr){sectionHdr.textContent='Elige el acabado';sectionHdr.classList.remove('cf-fin-required');}

      // V4 Fase 2.5: detener halo + limpiar attention
      finishWrap.classList.remove('cf-fin-needs-choice');
      finishWrap.classList.remove('cf-fin-attention');
      finishWrap.classList.add('cf-fin-choice-made');

      // V10: Maintain pre-order badges after selection
      updatePreorderPills(model);

      // V10: Guard CTA — don't restore normal if pre-order is active
      var finishIsPreorder = isFinishPreorder(model, isMate ? 'Matte Premium' : 'Glossy');
      if (!finishIsPreorder && typeof syncATCButtonState === 'function') {
        syncATCButtonState();
      }

      LOG(isUserAction ? 'Usuario seleccionó:' : 'Auto-seleccionado:', finish, '| Modelo:', model);
    } finally {
      _updating = false;
    }
  }

  // Click listeners
  finishWrap.querySelector('.cf-fin-card.mate').addEventListener('click', function () { selectFinish('matte', true); });
  finishWrap.querySelector('.cf-fin-card.glossy').addEventListener('click', function () { selectFinish('glossy', true); });

  // Keyboard accessibility
  finishWrap.querySelectorAll('.cf-fin-card').forEach(function (card) {
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.click();
      }
    });
  });

  // === V10: SINGLE INIT — replaces triple flow ===
  function initFinishSelector(hasPreorderAPI) {
    var model = modelSelect ? modelSelect.value : '';
    var matte = hasMatte(model);

    if (!matte) {
      // Model without matte — Glossy only, hide selector
      finishWrap.style.display = 'none';
      if (acabadoSelect && acabadoSelect.value !== 'Glossy') {
        acabadoSelect.value = 'Glossy';
        acabadoSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      showMagsafeForGlossy();
      selectFinish('glossy', false);
      LOG('V10 Init: modelo sin Matte', model);
      return;
    }

    // Model with matte — show selector
    finishWrap.style.display = '';
    setNeutralState();

    // Deep link support
    var urlParams = new URLSearchParams(window.location.search);
    var keepFinish = urlParams.get('cf_finish_intent') === '1';
    if (keepFinish && _savedInitialFinish === 'Matte Premium') {
      selectFinish('matte', false);
      LOG('V10 Init: deep link Matte');
      return;
    }
    if (keepFinish && _savedInitialFinish === 'Glossy') {
      selectFinish('glossy', false);
      LOG('V10 Init: deep link Glossy');
      return;
    }

    // Pre-Order default inteligente
    if (hasPreorderAPI) {
      var matePO = isFinishPreorder(model, 'Matte Premium');
      var glossyPO = isFinishPreorder(model, 'Glossy');
      updatePreorderPills(model);

      if (glossyPO && !matePO) {
        selectFinish('matte', false);
        LOG('V10 Init: Glossy Pre-Order → default Mate');
        return;
      }
      if (matePO && !glossyPO) {
        selectFinish('glossy', false);
        LOG('V10 Init: Mate Pre-Order → default Glossy');
        return;
      }
    }

    // V10.1: Modelo con Matte sin Pre-Order → FORCED CHOICE
    // setNeutralState() ya fue llamado arriba — no auto-select
    LOG('V10.1 Init: forced choice activo', hasPreorderAPI ? '(sin PO)' : '(API pending)');
  }

  // V10: Wait for COVRFLY_PREORDER API with polling (Bug 10 fix)
  function bootSelector() {
    var apiReady = window.COVRFLY_PREORDER && typeof window.COVRFLY_PREORDER.isPreorder === 'function';

    if (apiReady) {
      initFinishSelector(true);
      revealPrice();
      return;
    }

    // API not ready — init with fallback, then retry
    initFinishSelector(false);
    revealPrice();

    var retryCount = 0;
    var maxRetries = 20; // 20 * 100ms = 2s
    var retryTimer = setInterval(function () {
      retryCount++;
      if (window.COVRFLY_PREORDER && typeof window.COVRFLY_PREORDER.isPreorder === 'function') {
        clearInterval(retryTimer);
        LOG('V10: COVRFLY_PREORDER ready after', retryCount * 100, 'ms — re-init');
        initFinishSelector(true);
        return;
      }
      if (retryCount >= maxRetries) {
        clearInterval(retryTimer);
        LOG('V10: COVRFLY_PREORDER timeout — staying with fallback');
      }
    }, 100);
  }

  function revealPrice() {
    if (priceBlock && priceHidden) {
      setTimeout(function () {
        priceBlock.style.opacity = '1';
        priceHidden = false;
        LOG('Precio visible');
      }, 300);
    }
  }

  // Model change listener
  if (modelSelect) {
    modelSelect.addEventListener('change', function () {
      setTimeout(function () {
        var apiReady = window.COVRFLY_PREORDER && typeof window.COVRFLY_PREORDER.isPreorder === 'function';
        initFinishSelector(apiReady);
        // Update MagSafe icons (same as before)
        var model = modelSelect ? modelSelect.value : '';
        var samsung = isSamsung(model);
        var hasNo = modelHasNoVariant(model);
        var showMagIcons = !samsung && !hasNo;
        var isMate = _currentFinish === 'matte';

        var mateBigIcon = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-icon');
        if (mateBigIcon) mateBigIcon.style.display = (isMate && !samsung) ? 'flex' : 'none';
        var mateSmallIcon = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-mag-icon');
        if (mateSmallIcon) mateSmallIcon.style.display = (!isMate && !samsung) ? 'inline-flex' : 'none';
        var magText = finishWrap.querySelector('.cf-fin-card.mate .cf-fin-card-mag');
        if (magText) magText.style.display = samsung ? 'none' : '';
        var glossyBigIcon = finishWrap.querySelector('.cf-fin-glossy-icon');
        if (glossyBigIcon) glossyBigIcon.style.display = (!isMate && showMagIcons) ? 'flex' : 'none';
        var glossySmallIcon = finishWrap.querySelector('.cf-fin-card.glossy .cf-fin-mag-icon');
        if (glossySmallIcon) glossySmallIcon.style.display = (isMate && showMagIcons) ? 'inline-flex' : 'none';
        var glossyMag = finishWrap.querySelector('.cf-fin-glossy-mag');
        if (glossyMag) glossyMag.style.display = showMagIcons ? '' : 'none';
      }, 10);
    });
  }

  // V10: SINGLE BOOT — no triple flow
  bootSelector();

  // Retry: magsafe-wrap puede no existir aún (defer timing)
  if (!document.getElementById('covrfly-magsafe-wrap')) {
    setTimeout(function () {
      var model = modelSelect ? modelSelect.value : '';
      if (hasMatte(model) && _currentFinish === 'matte' && !isSamsung(model)) {
        hideMagsafeForMate();
      }
    }, 200);
  }

  // v2: ATC Gate
  function showFinishRequiredHint(){
    // V4 Fase 2.7: NO cambiar texto del header. Activar attention (fondo+halo).
    finishWrap.classList.add('cf-fin-attention');
    var sc=finishWrap.querySelector('.cf-fin-cards-section');
    if(sc){sc.classList.add('cf-fin-pulse');setTimeout(function(){sc.classList.remove('cf-fin-pulse');},950);}
    window.clearTimeout(finishWrap._cfAttentionTimer);
    finishWrap._cfAttentionTimer=window.setTimeout(function(){
      finishWrap.classList.remove('cf-fin-attention');
    },4000);
  }
  function shouldGateATC(){var m=modelSelect?modelSelect.value:'';return hasMatte(m)&&!_userHasChosenFinish&&_currentFinish==='none';}
  function bindATCGate(){document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){if(f.dataset.cfFinishGuardBound==='true')return;f.dataset.cfFinishGuardBound='true';f.addEventListener('submit',function(e){if(!shouldGateATC())return;e.preventDefault();e.stopPropagation();finishWrap.scrollIntoView({behavior:'smooth',block:'center'});showFinishRequiredHint();},true);});document.querySelectorAll('button[name="add"],.product-form__submit,[data-add-to-cart]').forEach(function(b){if(b.dataset.cfFinishClickGuardBound==='true')return;b.dataset.cfFinishClickGuardBound='true';b.addEventListener('click',function(e){if(!shouldGateATC())return;e.preventDefault();e.stopPropagation();finishWrap.scrollIntoView({behavior:'smooth',block:'center'});showFinishRequiredHint();},true);});}
  bindATCGate();setTimeout(bindATCGate,1500);setTimeout(bindATCGate,3000);

  LOG('V10.0.0 completo');

  window.__covrflyFinish = {
    cleanup: function () {
      var s = document.getElementById('covrfly-finish-styles');
      var w = document.getElementById('covrfly-finish-wrap');
      if (s) s.remove();
      if (w) w.remove();
      if (acabadoContainer) acabadoContainer.classList.remove('cf-fin-hidden');
      var msWrap = document.getElementById('covrfly-magsafe-wrap');
      if (msWrap) msWrap.classList.remove('cf-fin-magsafe-hidden');
      if (priceBlock) { priceBlock.style.opacity = '1'; priceBlock.style.transition = ''; }
      delete window.__covrflyFinish;
      LOG('Cleanup completo');
    },
    version: '10.0.0',
    setFinish: function (f) { selectFinish(f === 'matte' ? 'matte' : 'glossy', false); },
    getState: function () {
      return {
        finish: _currentFinish,
        model: modelSelect ? modelSelect.value : '',
        visible: finishWrap.style.display !== 'none'
      };
    }
  };

  finishDone();
})();